<template>
<div class="main detail-view no-sub-header" id="detail-4473-clean" style="position: relative; grid-template-columns: 250px 1fr auto;">
	<div class="filters">
		<label>ATF Revision {{ form.version < 4 ? 'December 2022' : 'August 2023' }}</label>
		<div class="divider"></div>
		<div class="form-contact">
			<div><b>{{ contactData.full_name || contactData.first_name + ' ' + contactData.middle_name + ' ' + contactData.last_name + ' ' + contactData.suffix }}</b></div>
			<label v-if="contactData.address_1">{{ contactData.address_1 }}<br></label>
			<label v-if="contactData.city">{{ contactData.city + ' ' + contactData.state + ' ' + contactData.zip_code }}<br></label>
			<label v-if="contactData.phone_number">{{ contactData.phone_number }}<br></label>
			<label v-if="contactData.email_address">{{ contactData.email_address }}</label>
		</div>

		<div class="divider"></div>

		<div v-if="form.form_data" class="section-list">
			<div :class="['pointer', { bold: formSection == 'section_a' }]" @click="showSection('section_a')"><i class="fas fa-check-circle" :class="{ section_complete: sectionComplete('A') }"></i> Section A <span class="section-owner">Employee</span></div>
			<div :class="['pointer', { bold: formSection == 'section_b' }]" @click="showSection('section_b')"><i class="fas fa-check-circle" :class="{ section_complete: sectionComplete('B') }"></i> Section B <span class="section-owner"><span v-if="sectionBAlert" class="error">Needs Review</span><span v-else>Customer</span></span></div>
			<div :class="['pointer', { bold: formSection == 'section_c' }]" @click="showSection('section_c')"><i class="fas fa-check-circle" :class="{ section_complete: sectionComplete('C') }"></i> Section C <span class="section-owner">Employee</span></div>
			<div :class="['pointer', { bold: formSection == 'section_d' }]" @click="showSection('section_d')"><i class="fas fa-check-circle" :class="{ section_complete: sectionComplete('D') }"></i> Section D <span class="section-owner">Customer</span></div>
			<div :class="['pointer', { bold: formSection == 'section_e' }]" @click="showSection('section_e')"><i class="fas fa-check-circle" :class="{ section_complete: sectionComplete('E') }"></i> Section E <span class="section-owner">Employee</span></div>
		</div>

		<div class="input-with-control">
			<input type="text" v-model="form.form_number" placeholder="Transaction SN" style="margin: 0;">
			<div class="button neutral" style="margin: 0;" @click="saveFormNumber()"><i class="fas fa-check"></i></div>
		</div>

		<div class="divider"></div>
		<div v-if="form.internal_use_only == 1" class="two-one-columns">
			<label>Your initials are requried for corrections...</label>
			<input type="text" maxlength="3" v-model="userInitials" ref="user_initials">
		</div>
		<div v-if="form.internal_use_only" :class="['button', userInitials.length < 2 ? 'disabled' : 'action']" @click="moveAndSaveSection()">Save Corrections</div>
		<div v-else :class="['button', lockSection(formSection) ? 'disabled' : 'action']" @click="saveSection()">Save Section {{ formSection.replace('section_', '').toUpperCase() }}</div>
		<div class="button neutral" @click="backToList()">Back to List</div>

		<div class="divider"></div>

		<div v-if="form.moved_to_ffl_log_book_form_id">
			<div>This form has been corrected.</div>
			<div style="margin: 0 0 0 0.5em"><router-link :to="'/logbooks/4473/' + form.moved_to_ffl_log_book_form_id" class="extra-menu-item">&rarr; View Corrected Version</router-link></div>
			<div class="divider"></div>
			<div v-if="associated3310s.length > 0" v-for="form in associated3310s" :key="form.ffl_log_book_form_id" class="extra-menu-item">
				<router-link  :to="'/logbooks/3310/' + form.ffl_log_book_form_id">3310 {{ form.pdf_required ? ' Not Submitted' : 'Submitted ' + $moment(form.cleo_forward_date).format('MM/DD/YYYY') }}</router-link>
			</div>
			<div class="extra-menu-item disabled">Dispose Firearms</div>
			<div class="extra-menu-item disabled">Add / View Attachments</div>
			<div v-if="clientHasVariance" class="extra-menu-item" @click="showCorrections = true">View Corrections</div>
			<div class="extra-menu-item disabled">View as PDF</div>
			<div class="extra-menu-item disabled" >{{ form.bookmarked ? 'Unbookmark' : 'Bookmark' }} this 4473</div>
			<div class="extra-menu-item disabled">Open Customer Kiosk</div>
			<div class="divider"></div>
			<div class="extra-menu-item disabled">{{ form.inactive ? 'Reactivate' : 'Cancel' }} this 4473</div>
		</div>
		<div v-else>
			<div v-if="associated3310s.length > 0" v-for="form in associated3310s" :key="form.ffl_log_book_form_id" class="extra-menu-item">
				<router-link  :to="'/logbooks/3310/' + form.ffl_log_book_form_id">3310 {{ form.pdf_required ? ' Not Submitted' : 'Submitted ' + $moment(form.cleo_forward_date).format('MM/DD/YYYY') }}</router-link>
			</div>
			<div class="extra-menu-item" @click="checkCanDispose()">Dispose Firearms</div>
			<div class="extra-menu-item" @click="showAttachments = true">Add / View Attachments</div>
			<div v-if="clientHasVariance" class="extra-menu-item" @click="showCorrections = true">Make / View Corrections</div>
			<div class="extra-menu-item"><a :href="generatePDFLink()" target="_blank">View as PDF</a></div>
			<div class="extra-menu-item" @click="bookmarkForm()">{{ form.bookmarked ? 'Unbookmark' : 'Bookmark' }} this 4473</div>
			<div class="extra-menu-item"><a href="/dashboard/logbooks/customer-4473" target="_blank">Customer Kiosk</a></div>
			<div class="divider"></div>
			<div class="extra-menu-item" @click="confirmCancel = true">{{ form.inactive ? 'Reactivate' : 'Cancel' }} this 4473</div>

		</div>
	</div>

	<div v-if="form.form_data" class="detail form-detail" ref="section_top">
		<section-a v-if="formSection == 'section_a'" :form="form" :transaction_info="firearmsTransactionInfo" :locked="lockSection('section_a')" ref="sectionA" :key="'section_a_' + form.ffl_log_book_form_id" />
		<section-b-2022 v-if="formSection == 'section_b' && form.version == '3'" :form="form" :locked="lockSection('section_b')" ref="sectionB" :enableSignOnScreen="enableSignOnScreen" :key="'section_b_' + form.ffl_log_book_form_id" />
		<section-b-2023 v-if="formSection == 'section_b' && form.version == '4'" :form="form" :transaction_info="firearmsTransactionInfo" :locked="lockSection('section_b')" ref="sectionB" :enableSignOnScreen="enableSignOnScreen" :key="'section_b_' + form.ffl_log_book_form_id" />
		<section-c-2022 v-if="formSection == 'section_c' && form.version == '3'" :form="form" :contactData="contactData" :locked="lockSection('section_c')" ref="sectionC" :key="'section_c_' + form.ffl_log_book_form_id" />
		<section-c-2023 v-if="formSection == 'section_c' && form.version == '4'" :form="form" :contactData="contactData" :locked="lockSection('section_c')" ref="sectionC" :key="'section_c_' + form.ffl_log_book_form_id" />
		<section-d v-if="formSection == 'section_d'" :form="form" :locked="lockSection('section_d')" ref="sectionD" :enableSignOnScreen="enableSignOnScreen" :key="'section_d_' + form.ffl_log_book_form_id" />
		<section-e-2022 v-if="formSection == 'section_e' && form.version == '3'" :form="form" :locked="lockSection('section_e')" ref="sectionE" :enableSignOnScreen="enableSignOnScreen" :key="'section_e_' + form.ffl_log_book_form_id" />
		<section-e-2023 v-if="formSection == 'section_e' && form.version == '4'" :form="form" :locked="lockSection('section_e')" ref="sectionE" :enableSignOnScreen="enableSignOnScreen" :key="'section_e_' + form.ffl_log_book_form_id" />

		<div class="mobile-spacer"></div>

	</div>

	<instructions-2022 v-if="form.version == '3'" :section="formSection" />
	<instructions-2023 v-if="form.version == '4'" :section="formSection" />

	<div v-if="showAttachments" class="modal medium-modal">
		<div class="inner">
			<h2>4473 Attachments</h2>
			<div class="content">
				<div class="two-columns">
					<div class="border-right">
						<h3>Current attachments</h3>
						<div v-if="attachments.length > 0">
							<div v-for="(file, index) in attachments" class="one-two-columns" style="position: relative; margin: 1em 0; padding: 1em 0 0 0; border-top: 1px solid #ccc;">
								<div class="center">
									<img v-if="file.file_preview_url" :src="file.file_preview_url" style="max-height: 7em;">
									<div v-else>No Preview<br>Available</div>
								</div>
								<div>
									<label>File Name</label>
									<p>{{ file.file_name }}</p>
									<label>File Type</label>
									<p>{{ file.file_type }}</p>
									<label>Attached Date / Time</label>
									<p>{{ file.attached_time }}</p>
								</div>
								<div class=" icon-button" style="position: absolute; top: 0; right: 0;" @click="removeFile(file)">
									<i class="fa fa-trash" />
									<div class="extra-menu-label">Delete</div>
								</div>
							</div>
						</div>
						<div v-else class="empty-list" style="width: 20em;">
							No files are attached<br>to this 4473
						</div>
					</div>
					<div>
						<h3>Add an attachment</h3>
						<div>
							<vue-dropzone @vdropzone-file-added="filesFileAdded" @vdropzone-success="filesUploadSuccess" @vdropzone-error="filesUploadError" ref="filesDropzone" id="site_background_dropzone" :options="filesDropzoneOptions"></vue-dropzone>
							<label><em>Allowed file types: pdf, jpg, png</em></label>
							<div class="dropzone dz-preview dz-file-preview uploaded-files" style="border: 0 none;"></div>
						</div>
					</div>
				</div>

				<div v-if="attachmentsMessage" class="message-overlay">
					<p v-html="attachmentsMessage"></p>
				</div>

			</div>
			<div class="controls">
				<div class="button cancel" @click="showAttachments = false; attachmentsMessage = ''">Done</div>
			</div>
		</div>
	</div>

	<div v-if="showCorrections" :class="['modal', changeLog.length > 0 ? 'large-modal' : 'medium-modal']">
		<div class="inner">
			<h2>4473 Corrections</h2>
			<div class="content">
				<div :class="changeLog.length > 0 ? 'three-one-columns' : 'two-one-columns'">
					<div :class="changeLog.length > 0 ? 'two-columns' : ''">
						<div>
							<h3>4473 Correction Rules</h3>
							<ul class="normal">
								<li><strong>Section A</strong> can be directly edited at any time before Section E is signed.</li>
								<li>Once <strong>Section B</strong> is signed it can <b>only</b> be corrected by moving the entire form to a new form and then having the customer (not the dealer) make corrections.</li>
								<li><strong>Section C</strong> can be fully edited at any time before Section E is signed.</li>
								<li>Once <strong>Section D</strong> is signed it can <b>only</b> be corrected by moving the entire form to a new form and then having the customer (not the dealer) make corrections.</li>
								<li>Once <strong>Section E</strong> is signed, Sections A, B, C, and D are "locked" and can <b>only</b> be corrected by moving the entire form to a new form.  Note the following exception for Section C.</li>
								<li><strong>Section C</strong> "After the firearm was transferred" and <strong>Section E</strong> "For Use by Licensee" can be updated at any time, even after Section E is signed.</li>
							</ul>
						</div>
						<div v-if="changeLog.length > 0" style="margin: 0 0 0 1em; padding: 0 0 0 1em; border-left: 1px solid #ccc;">
							<h3>Correction Log</h3>
							<div v-for="(change, index) in changeLog" class="border-bottom v-spaced">
								<div v-if="change.field_name == 'nics_number' || change.field_name == 'transfer_date'">
									<p>{{ change.section }}</p>
									<label class="full">Previous Value</label>
									<p>{{ change.old_value }}</p>
									<label class="full">Changed To</label>
									<p>{{ change.field_name == 'nics_number' ? form.nics_number : form.transfer_date }}</p>
								</div>
								<div v-else>
									<p>{{ change.section }}: {{ change.label }}</p>
									<label class="full">Previous Value</label>
									<p v-if="change.label.indexOf('Signature') > -1"><img class="signature" :src="change.old_value"></p>
									<p v-else>{{ change.old_value }}</p>
									<label class="full">Changed To</label>
									<p v-if="change.label.indexOf('Signature') > -1"><img class="signature" :src="getFieldValue(change.field_name)"></p>
									<!-- <p v-else>{{ getFieldValue(change.field_name) }}</p> -->
									<p v-else>{{ change.new_value }}</p>
								</div>
								<label class="full">Changed Time / Initials</label>
								<p>{{ change.log_time }} / {{ change.user_initials }}</p>
							</div>
							<div v-if="movedFromFormId" class="button neutral small" @click="goToDetail(movedFromFormId)">Show Previous Version</div>
						</div>
					</div>
					<div style="margin: 0 0 0 1em; padding: 0 0 0 1em; border-left: 1px solid #ccc;">
						<h3>What can I do?</h3>
						<div v-if="form.moved_to_ffl_log_book_form_id">
							<p>This form has been corrected.</p>
							<p>You can view the corrected version, but you cannot make further changes to this version.</p>
							<div v-if="form.moved_to_ffl_log_book_form_id" class="button neutral small" @click="goToDetail(form.moved_to_ffl_log_book_form_id)">View Corrected Version</div>
						</div>
						<div v-else-if="form.internal_use_only">
							<p>This form has been marked for correction.</p>
							<p>You can correct Sections A, C, or E here.</p>
							<p>Your customer can correct Section B or D in the kiosk.</p>
							<div class="button neutral small" @click="markFormForCorrection()">Unmark This Form</div>
						</div>
						<div v-else-if="form.form_data.section_e.seller_signature">
							<p>Section E has been signed.</p>
							<p>You can still edit Section C "After the firearm was transferred".</p>
							<p>You can also edit Section E notes and the "Not transferred" checkbox.</p>
							<p>You'll need to <b>mark this form for correction</b> in order make changes to Section {{ formSection.replace('section_', '').toUpperCase() }} or to have the customer make changes to Sections B or D.</p>
							<div class="button neutral small" @click="markFormForCorrection()">Mark This Form</div>
						</div>
						<div v-else>
							<div v-if="formSection == 'section_a'">
								<p>Section E has not been signed.</p>
								<p>You can update Section A as needed.</p>
							</div>
							<div v-if="formSection == 'section_b'">
								<div v-if="form.form_data.section_b.signature">
									<p>Section B has been signed by your customer.</p>
									<p>You can mark this form as awaiting correction, which will make it available in the Kiosk for your customer to correct as needed.</p>
									<div class="button neutral small" @click="markFormForCorrection()">Mark This Form</div>
								</div>
								<div v-else>
									<p>Section B has not been completed or signed.</p>
									<p>Your customer can complete Section B at any time.</p></div>
							</div>
							<div v-if="formSection == 'section_c'">
								<p>Section E has not been signed.</p>
								<p>You can update and save Section C as needed.</p>
							</div>
							<div v-if="formSection == 'section_d'">
								<div v-if="form.form_data.section_d.buyer_recertification_signature">
									<p>Section D has been signed by your customer.</p>
									<p>You can mark this form as awaiting correction, which will make it available in the Kiosk for your customer to correct as needed.</p>
									<div class="button neutral small" @click="markFormForCorrection()">Mark This Form</div>
								</div>
								<div v-else>
									<p>Section D has not been signed.</p>
									<p>Your customer can complete Section D if needed<span form.form_data.section_b.signature> after Section B has been completed</span>.</p>
								</div>
							</div>
							<div v-if="formSection == 'section_e'">
								<p>Section E has not been signed.</p>
								<p>You can update and save Section E as needed.</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="controls">
				<div class="button cancel" @click="showCorrections = false">Cancel</div>
			</div>
		</div>
	</div>

	<div v-if="confirmCancel" class="modal">
		<div class="inner">
            <h2>Confirm {{ this.form.inactive ? 'Re-activate' : 'Cancel' }}</h2>
            <div class="content">
                <p><strong>You are about to {{ this.form.inactive ? 're-activate this form' : 'mark this form as cancelled' }}.</strong></p>
                <p v-if="!this.form.inactive">Cancelled forms aren't normally shown in your 4473 list, but you can filter for them as needed.</p>
                <p>Are you sure you want to proceed?</p>
            </div>
            <div class="controls">
                <div class="button cancel spaced" @click="confirmCancel = false">No</div>
                <div class="primary button spaced" @click="cancelForm()">Yes</div>
            </div>
		</div>
	</div>

	<div v-if="confirmMarked" class="modal">
		<div class="inner">
            <h2 v-if="saveSuccess">Success!</h2>
            <h2 v-else>{{ form.internal_use_only ? 'Marked for correction' : 'Who will correct this form?' }}</h2>
            <div class="content">
				<div v-if="saveSuccess">
					<p class="center">Form has been <b>{{ form.internal_use_only ? 'marked' : 'unmarked' }}</b> for correction.</p>
					<div class="center">
						<i class="fa fa-check"></i>
					</div>
				</div>
				<div v-else-if="form.internal_use_only" class="center">
					<p>This form is awaiting correction to Sections B or D<br>by <b>{{ form.internal_use_only == 1 ? 'a manager' : 'the customer' }}</b>.</p>
				</div>
				<div v-else class="two-columns">
					<div>
						<h3>Customer</h3>
						<p>Sections B or D need to be corrected by the customer. This form will be <b>locked</b> until customer completes corrections at the Kiosk.</p>
						<div :class="['button', saving ? 'disabled' : 'action', 'spaced']" @click="markFormForCorrection('customer')">Customer Will Correct</div>
					</div>
					<div>
						<h3>Manager</h3>
						<p>Sections A, C, or E need to be corrected by a manager. This form will be <b>unavailable</b> for customer corrections at the Kiosk.</p>
						<div :class="['button', saving ? 'disabled' : 'action', 'spaced']" @click="markFormForCorrection('manager')">Manager Will Correct</div>
					</div>
				</div>
				<div v-if="saving" class="center">
					<i class="fas fa-spinner fa-spin"></i>
				</div>
            </div>
            <div class="controls">
				<div v-if="form.internal_use_only && !saveSuccess" :class="['button', saving ? 'disabled' : 'action', 'spaced']" @click="markFormForCorrection('unmark')">Unmark For Correction</div>
                <div class="button cancel" @click="confirmMarked = false">Cancel</div>
            </div>
		</div>
	</div>

	<div v-if="showReasonDisposeLocked" class="modal">
		<div class="inner">
			<h2>Dispose This Form</h2>
			<div class="content">
				<p class="center">
					Dispose This Form is locked because<br>
					<span v-if="form.form_number">you have saved a Transaction Serial Number.</span>
					<span v-else>Section E has not been signed.</span>
				</p>
			</div>
            <div class="controls">
                <div class="button cancel spaced" @click="showReasonDisposeLocked = false">Got It</div>
            </div>
		</div>
	</div>

	<message-modal v-if="message" :message="message" :loading="saving" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" @action="doMessageModalAction()" />

	<help-popup :helpLink="{198:'Begin a 4473', 199:'4473 Section A', 200:'4473 Section B', 205:'4473 Section C / Start NICS Check', 203:'NICS Online Check', 204:'NICS Phone Check', 381:'4473 Section D', 382:'4473 Section E / Completing a 4473', 383:'4473 Attachments', 384:'Correcting a 4473 Form'}" :tours="false"></help-popup>

</div>

</template>

<script>
import styles from '../detail_4473_clean.scss'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import BinaryToggle from '@/components/BinaryToggle.vue'

// using arrow functions to lazy load components
// https://vuedose.tips/dynamic-imports-in-vue-js-for-better-performance
const SectionA = () => import('../components/4473SectionA.vue')
const SectionB2023 = () => import('../components/4473SectionB2023.vue')
const SectionB2022 = () => import('../components/4473SectionB2022.vue')
const SectionC2023 = () => import('../components/4473SectionC2023.vue')
const SectionC2022 = () => import('../components/4473SectionC2022.vue')
const SectionD = () => import('../components/4473SectionD.vue')
const SectionE2023 = () => import('../components/4473SectionE2023.vue')
const SectionE2022 = () => import('../components/4473SectionE2022.vue')
const Instructions2023 = () => import('../components/Instructions2023.vue')
const Instructions2022 = () => import('../components/Instructions2022.vue')

import { runInThisContext } from 'vm'
import HelpPopup from '@/components/HelpPopup.vue'

export default {
	name: 'form4473-detail-clean',
	props: ['ffl_log_book_form_id'],
    components: {
        'vue-dropzone': vue2Dropzone,
        'binary-toggle': BinaryToggle,
        'section-a': SectionA,
        'section-b-2022': SectionB2022,
        'section-b-2023': SectionB2023,
        'section-c-2022': SectionC2022,
        'section-c-2023': SectionC2023,
        'section-d': SectionD,
        'section-e-2022': SectionE2022,
        'section-e-2023': SectionE2023,
		'instructions-2022': Instructions2022,
		'instructions-2023': Instructions2023,
		'help-popup': HelpPopup
    },
	data() {
		return {
			loading: false,
			message: '',
			contactData: {},
			form: {},
			associated3310s: [],
			attachments: [],
			changeLog: [],
			movedFromFormId: '',
			attachmentsMessage: '',
			formSection: 'section_a',
			forceSave: false,
			startNewForm: false,
			message: '',
			saving: false,
			saveSuccess: false,
			messageStatus: '',
			messageTimeout: 0,
			spanishLanguage: '',
			showAttachments: false,
			showCorrections: false,
			confirmCancel: false,
			showExport: false,
			clientHasVariance: '',
			enableSignOnScreen: '',
			sectionESignatureSaved: false,
			userInitials: '',
			originalForm: '',
			showReasonDisposeLocked: false,
			today: '',
			todayFormatted: '',
			confirmMarked: false,
			firearmsTransactionInfo: ''
		}
	},
	created() {
		let theDate = new Date()
		this.today = theDate.getFullYear() + '-' + (theDate.getMonth() + 1).toString().padStart(2,'0') + '-' + theDate.getDate()
		this.todayFormatted = (theDate.getMonth() + 1).toString().padStart(2,'0') + '/' + theDate.getDate().toString().padStart(2,'0') + '/' + theDate.getFullYear()
		if (this.ffl_log_book_form_id && this.ffl_log_book_form_id != 'new') {
			this.fetchData()
		}
	},
	watch: {
		'ffl_log_book_form_id' (newVal) {
			this.fetchData()
		}
	},
	computed: {
        sectionBAlert() {
            return this.form.customer_disqualified
        },
        filesDropzoneOptions() {
            return {
    			url: this.getApiEndpoint + '?action=upload_form_attachments',
    			withCredentials: true,
    			uploadMultiple: false,
    			paramName: 'upload_file',
    			maxFilesize: 4,
                createImageThumbnails: false,
                acceptedFiles: 'image/jpeg,image/png,application/pdf',
                previewsContainer: '.uploaded-files',
    			params: {
    				fd_token: this.$getCookie('dashboard_token'),
    				source: 'LOGBOOKS',
                    ffl_log_book_form_id: this.ffl_log_book_form_id
    			}
            }
        }
	},
	methods: {
		fetchData() {
			if (this.loading) { return }
			this.loading = true
			this.apiCall({ destination: 'get_item_ffl_log_book_form', data: { ffl_log_book_form_id: this.ffl_log_book_form_id } }).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					if (obj.log_book_form.version < 3) {
						this.$router.push('/logbooks/4473-v2/' + this.ffl_log_book_form_id)
					}
					this.contactData = obj.contact_data
					// using sectionESignatureSaved allows user to update sellers signature without immediately locking section
					this.sectionESignatureSaved = obj.log_book_form.form_data.section_e.seller_signature && obj.log_book_form.form_data.section_e.seller_signature != ''
					this.form = obj.log_book_form
					this.associated3310s = obj.associated_3310s
					this.originalForm = JSON.stringify(this.form) // we'll use this to confirm changes have been made before saving / moving
					this.changeLog = obj.change_log
					this.movedFromFormId = obj.moved_from_ffl_log_book_form_id
					this.clientHasVariance = obj.electronic_storage_variance
	                this.enableSignOnScreen = obj.enable_screen_capture_signature
					this.firearmsTransactionInfo = obj.firearms_transaction_info
					this.getLogBookFormAttachments()
				} else {
					this.message = obj.message
				}
			})
		},
		sectionComplete(section) {
			let sectionComplete = false
			switch (section) {
				case 'A':
					if (this.form.section_completed && this.form.form_data.section_a.firearms_list && this.form.form_data.section_a.firearms_list.length > 0) {
						sectionComplete = true
					}
					break
				case 'B':
					if (this.form.section_completed > 'A' && this.form.form_data.section_b.signature) {
						sectionComplete = true
					}
					break
				case 'C':
					if (this.form.section_completed > 'B' && !Object.values(this.form.form_data.section_c.customer_trans_purpose).every(x => x === null || x === '')) {
						sectionComplete = true
					}
					break
				case 'D':
					if (this.form.section_completed > 'C' && this.form.form_data.section_d.buyer_recertification_date) {
						sectionComplete = true
					}
					break
				case 'E':
					if (this.form.section_completed == 'E' && this.form.form_data.section_e.seller_signature) {
						sectionComplete = true
					}
					break
			}
			return sectionComplete
		},
		showSection(section) {
			if (section == this.formSection) { return }
			this.formSection = section
			this.sectionSearchTerm = ''
			this.sectionSearchMessage = ''
			this.showExtraSearchControl = false
			// alert the user if section e and if today is later than section b signed date and no section d
			// NOTE: uncomment lockSection code (and showLockedReason code in 4473SectionE.vue) if we decide to actually lock section e
			// if (section == 'section_e' && !this.form.form_data.section_e.seller_signature && this.form.form_data.section_b.signed_date < this.todayFormatted && !this.form.form_data.section_d.buyer_recertification_date) {
			// 	this.messageStatus = 'alert'
			// 	this.message = 'Section B signed date ' + this.form.form_data.section_b.signed_date + ' has passed.<br>Your customer should complete Section D before transfer.'
			// }
		},
		lockSection(section) {
			if (!this.form.form_data) { return true }
			switch (section) {
				case 'section_a':
					if (this.form.internal_use_only == 1) { return false }
					if (this.form.internal_use_only == 2) { return true }
					if (this.form.form_data.section_e.seller_signature && this.form.form_data.section_e.seller_signature != '') { return true }
					if (this.form.moved_to_ffl_log_book_form_id) { return true }
					return false
				case 'section_b':
					return true // section_b is always locked when not in Kiosk!
				case 'section_c':
					if (this.form.internal_use_only == 1) { return false }
					if (this.form.internal_use_only == 2) { return true }
					if (this.form.form_data.section_e.seller_signature && this.form.form_data.section_e.seller_signature != '') { return true }
					if (this.form.section_completed < 'B' || this.form.moved_to_ffl_log_book_form_id) { return true }
					return false
				case 'section_d':
					return true // section_d is always locked when not in Kiosk!
				case 'section_e':
					if (this.form.internal_use_only == 1) { return false }
					if (this.form.internal_use_only == 2) { return true }
					let locked = false
					if (this.sectionESignatureSaved || this.form.section_completed < 'C' || this.form.moved_to_ffl_log_book_form_id > 0) {
						locked = true
					}
					// certain things in section C must also be saved
					if (Object.values(this.form.form_data.section_c.customer_trans_purpose).every(x => x === null || x === '')) {
						locked = true
					}
					if (!this.form.form_data.section_c.buyer_identification_issuing_authority_and_type) {
						locked = true
					}
					if (!this.form.form_data.section_c.buyer_identification_type_code) {
						locked = true
					}
					if (!this.form.form_data.section_c.buyer_identification_number) {
						locked = true
					}
					if (!this.form.form_data.section_c.nics_buyer_background_check && !this.form.form_data.section_c.nics_buyer_exempt && !this.form.form_data.section_c.nics_buyer_exempt_permit_state_type && !this.form.form_data.section_c.nics_initial_response_date) {
						locked = true
					}
					if (!this.form.form_data.section_c.nics_buyer_background_check && !this.form.form_data.section_c.nics_buyer_exempt && !this.form.form_data.section_c.nics_buyer_exempt_permit_state_type && !this.form.nics_number && !this.form.form_data.section_c.no_nics_number_provided) { 
						locked = true
					}
					if (!this.form.form_data.section_c.nics_buyer_background_check && !this.form.form_data.section_c.nics_buyer_exempt && !this.form.form_data.section_c.nics_buyer_exempt_permit_state_type && !this.form.form_data.section_c.nics_initial_response) {
						locked = true
					}
					// if the current date is later than the Section B signed date, and no Section D
					//if (!this.form.form_data.section_e.seller_signature && this.form.form_data.section_b.signed_date < this.todayFormatted && !this.form.form_data.section_d.buyer_recertification_date) {
					//	locked = true
					//}
					return locked
			}
		},
		bookmarkForm() {
			this.apiCall({ destination: 'save_item_ffl_log_book_form_bookmark', data: { ffl_log_book_form_id: this.ffl_log_book_form_id, bookmark: !this.form.bookmarked } }).then((obj) => {
				if (obj.status == 'success') {
                    this.form.bookmarked = !this.form.bookmarked
				}
			}).catch((err) => {
				console.log(err)
			})
		},
		saveSection() {
			if (this.saving) { return }
			if (this.lockSection(this.formSection)) { return }
			if (this.form.internal_use_only) {
				this.moveAndSaveSection()
				return
			}
			this.saving = true
			this.message = 'Saving Section ' + this.formSection.replace('section_', '').toUpperCase()
			this.messageTimeout = 0
			let errorMessage = ''
			if (this.formSection == 'section_a') {
				errorMessage = this.$refs.sectionA.validateSection()
			}
			if (this.formSection == 'section_b') {
				errorMessage = this.$refs.sectionB.validateSection()
			}
			if (this.formSection == 'section_c') {
				errorMessage = this.$refs.sectionC.validateSection()
			}
			if (this.formSection == 'section_d') {
				errorMessage = this.$refs.sectionD.validateSection()
			}
			if (this.formSection == 'section_e') {
				errorMessage = this.$refs.sectionE.validateSection()
			}
			if (errorMessage) {
				this.message = errorMessage
				this.saving = false
				this.messageStatus = 'invalid'
				return false
			}

			this.message = 'Saving 4473 Section ' + this.formSection.replace('section_', '').toUpperCase()
			let data = {
                ffl_log_book_form_id: this.ffl_log_book_form_id,
                form: this.form,
                form_section: this.formSection,
				version: 3,
                force_save: this.forceSave
            }

			this.apiCall({ destination: 'save_4473_section', data: data }).then(obj => {
				this.saving = false
				this.messageStatus = obj.status
                if (obj.status == 'success') {
					this.message = '4473 Section ' + this.formSection.replace('section_', '').toUpperCase() + ' saved!'
					this.messageTimeout = 3000
					this.fetchData()
                } else {
                    this.message = obj.message
                }
            })
		},
        saveFormNumber() {
			if (this.saving) { return } // || !this.form.form_number
			this.saving = true
			this.message = 'Saving transaction serial number'
			this.apiCall({ destination: 'save_4473_form_number', data: { ffl_log_book_form_id: this.ffl_log_book_form_id, form_number: this.form.form_number } }).then(obj => {
				this.saving = false
				if (obj.status == 'success') {
					this.message = 'Transaction serial number saved!'
					this.messageTimeout = 3000
					this.fetchData()
				} else {
                    this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
        markFormForCorrection(which) {
			if (!which) {
				this.confirmMarked = true
				this.showCorrections = false
				return
			}
			if (this.saving) { return }
			this.saveSuccess = false
			this.saving = true
			this.showCorrections = false
			// this.messageTimeout = 0
			// this.message = (this.form.internal_use_only > 0 ? 'Unmarking' : 'Marking') + 'form for correction'
			let internalUseOnly = 0
			switch (which) {
				case 'customer':
					internalUseOnly = 2
					break
				case 'manager':
					internalUseOnly = 1
					break
				case 'unmark':
					internalUseOnly = 0
					break
			}
			this.apiCall({ destination: 'save_4473_internal_use_only', data: { ffl_log_book_form_id: this.ffl_log_book_form_id, internal_use_only: internalUseOnly } }).then((obj) => {
				this.saving = false
				this.saveSuccess = true
				this.form.internal_use_only = obj.internal_use_only
				this.originalForm = JSON.stringify(this.form) // recopy to originalForm to confirm changes have been made before saving / moving
				setTimeout(() => {
					this.confirmMarked = false
					this.saveSuccess = false
				}, 2000)
			}).catch((err) => {
				console.log(err)
			})
        },
		moveAndSaveSection() {
			if (this.saving) { return }
            this.saving = true
			this.message = ""
			this.messageStatus = ''
			if (JSON.stringify(this.form) == this.originalForm) {
				this.saving = false
				this.message = "You haven't made any changes!"
				this.messageStatus = 'invalid'
				return
			}
			let errorMessage = ''
			if (this.formSection == 'section_a') {
				errorMessage = this.$refs.sectionA.validateSection()
			}
			if (this.formSection == 'section_c') {
				errorMessage = this.$refs.sectionC.validateSection()
			}
			if (this.formSection == 'section_e') {
				errorMessage = this.$refs.sectionE.validateSection()
			}
			if (!errorMessage && this.userInitials.length < 2) {
				errorMessage = 'Your initials are required for corrections.'
				this.$refs.user_initials.focus()
			}
			if (errorMessage) {
				this.saving = false
				this.message = errorMessage
				this.messageStatus = 'invalid'
				return false
			}
			this.message = 'Saving Corrected 4473 Section ' + this.formSection.replace('section_', '').toUpperCase()
			this.saving = true
			// start with the full contact object return from get_item_ffl_log_book_form so we don't overwrite email address and other "extra" fields
			let contactData = this.contactData
			contactData.first_name = this.form.form_data.section_b.first_name
			contactData.middle_name = this.form.form_data.section_b.middle_name
			contactData.last_name = this.form.form_data.section_b.last_name
			contactData.address_1 = this.form.form_data.section_b.address_1
			contactData.city = this.form.form_data.section_b.city
			contactData.state = this.form.form_data.section_b.state
			contactData.zip_code = this.form.form_data.section_b.zip_code
			contactData.birthdate = this.form.form_data.section_b.birthdate
			let data = {
				old_ffl_log_book_form_id: this.ffl_log_book_form_id,
				contact_id: this.form.contact_id,
                user_initials: this.userInitials,
				form_section: this.formSection,
				form: {
					version: this.form.version,
					nics_number: this.form.nics_number,
					transfer_date: this.form.transfer_date,
					status: this.form.status,
					form_data: this.form.form_data
				},
				contact: contactData
			}
			// send to server
			this.apiCall({ destination: 'move_item_4473', data: data }).then(obj => {
				this.saving = false
				if (obj.status == 'success') {
					this.message = 'Corrections to 4473 Section ' + this.formSection.replace('section_', '').toUpperCase() + ' saved!'
					this.messageTimeout = 2000
					setTimeout(() => { 
						this.$router.push('/logbooks/4473/' + obj.ffl_log_book_form_id) 
					}, 2000)
				} else {
					this.message = obj.message
					this.messageStatus = 'error'
					this.messageTimeout = 0
				}
			})
		},
		backToList() {
			this.$router.push('/logbooks/4473')
		},
        generateAttachmentLink(attachmentId) {
            let attachmentLink = this.getApiEndpoint + '?action=form_4473_attachment&source=logbooks&fd_token=' + getCookie('dashboard_token') + '&attachment_id=' + this.$randomString(6) + attachmentId + this.$randomString(6)
            attachmentLink += (this.$route.query.debug) ? "&debug=1" : ""
			return attachmentLink
		},
        getLogBookFormAttachments() {
            this.apiCall({ destination: 'get_log_book_form_attachments', data: { ffl_log_book_form_id: this.ffl_log_book_form_id } }).then(obj => {
                this.attachments = obj.file_reference
				this.attachmentsMessage = ''
            })
        },
        filesUploadSuccess(file, response) {
            var obj = JSON.parse(response)
			if (obj.status != 'success') {
				this.attachmentsMessage = obj.message
			} else {
				let data = {
					ffl_log_book_form_id: this.ffl_log_book_form_id,
					file_name: obj.file_name,
					file_type: obj.file_type
				}
				this.apiCall({ destination: 'save_log_book_form_attachments', data: data }).then(obj => {
				    if (obj.status != 'success') {
				        this.attachmentsMessage = obj.message
				    } else {
				        this.getLogBookFormAttachments()
				    }
				})
			}
        },
        filesUploadError(file, message, xhr) {
			// console.log('filesUploadError')
			// console.log(file)
			// console.log(message)
			// console.log(xhr)
            this.attachmentsMessage = message
		},
        filesFileAdded(file) {
            this.savingForm = true
            this.filesAdded++
        },
        removeFile(file) {
            this.apiCall({ destination: 'save_log_book_form_attachments', data: { ffl_log_book_form_id: this.ffl_log_book_form_id, file_name: file.file_name, delete: true } }).then(obj => {
                if (obj.status == 'success') {
                    this.getLogBookFormAttachments()
                }
            })
        },
        generatePDFLink() {
			let pdfLink = ''
			pdfLink = this.getPDFAPIEndpoint + '?action=form_4473_pdf&source=logbooks&fd_token=' + getCookie('dashboard_token') + '&form_id=' + this.$randomString(6) + this.ffl_log_book_form_id + this.$randomString(6) + this.form.client_id
			pdfLink += (this.$route.query.debug) ? "&debug=1" : ""
			return pdfLink
		},
        cancelForm() {
			this.apiCall({ destination: 'save_4473_inactive', data: { ffl_log_book_form_id: this.ffl_log_book_form_id, current_inactive: this.form.inactive } }).then((obj) => {
                this.backToList()
			}).catch((err) => {
				console.log(err)
			})
        },
		getFieldValue(field) {
			if (field == 'firearms_list') {
				return this.form.form_data.section_a.firearms_list
			}
			let fieldParts = field.split('.')
			if (fieldParts.length > 2) {
				return this.form.form_data[fieldParts[0]][fieldParts[1]][fieldParts[2]]
			} else {
				return this.form.form_data[fieldParts[0]][fieldParts[1]]
			}
		},
		goToDetail(formId) {
			this.showCorrections = false
			this.$router.push('/logbooks/4473/' + formId)
		},
		checkCanDispose() {
			if (this.saving) { return }
			this.saving = true
			this.messageTimeout = 0
			this.message = 'Checking Form'
			if (!this.sectionComplete('E')) {
				this.saving = false
				this.messageStatus = 'alert'
				this.message = "Can't dispose firearms in this form<br>because Section E hasn't been completed."
				return
			}
			if (this.form.form_number) {
				this.saving = false
				this.messageStatus = 'alert'
				this.message = "Can't dispose firearms in this form<br>it has a Transaction Serial Number."
				return
			}
			this.apiCall({ destination: 'get_item_ffl_log_book_form_for_disposal', data: { ffl_log_book_form_id: this.form.ffl_log_book_form_id } }).then((obj) => {
				this.saving = false
				if (obj.status == 'success') {
					this.message = 'Transferring to the Dispose program...'
					this.messageTimeout = 1500
					setTimeout(() => { 
						this.$router.push('/logbooks/dispose?form=' + this.form.ffl_log_book_form_id)
					}, 1500)
				} else {
					this.messageStatus = obj.status
					this.message = "Can't dispose firearms in this form.<br><br>" + obj.message
				}
			}).catch((err) => {
				console.log(err)
				this.loadingModal = false
			})
		}
	}
}
</script>
